import React from 'react';
import Konva from 'konva';
import { Image } from "react-konva";
import useImage from "use-image";
import locked from "assets/svgs/locked.svg";

const ElementLockedAddIn = React.forwardRef((_props, ref) => {
  const [img] = useImage(locked);

  return <Image ref={ref as React.MutableRefObject<Konva.Image>} x={0}  y={0} image={img} />;
});

export default ElementLockedAddIn;